import React, { Component, ErrorInfo, ReactNode } from 'react';

interface ErrorBoundaryProps {
	children: ReactNode;
}

interface ErrorBoundaryState {
	hasError: boolean;
	error: Error | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = {
			hasError: false,
			error: null,
		};
	}

	static getDerivedStateFromError(error: Error): ErrorBoundaryState {
		return {
			hasError: true,
			error,
		};
	}

	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error('Error caught by boundary:', error, errorInfo);
	}

	handleReload = () => {
		window.location.reload();
	};

	render() {
		const { children } = this.props;
		const { hasError, error } = this.state;

		if (hasError) {
			return (
				<div style={{ padding: '20px', textAlign: 'center' }}>
					<h1>Something went wrong</h1>
					<p>{error?.message}</p>
					<button onClick={this.handleReload}>Reload Page</button>
				</div>
			);
		}

		return children;
	}
}

export default ErrorBoundary;
